import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../contexts/AuthContext';

export default function Home() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api
      .get('/api/deck/stats')
      .then((res) => setStats(res.data))
      .catch(() => setStats(null));
  }, []);

  const choose = (type) => navigate(`/pick?type=${type}`);

  return (
    <div className="mp-home">
      <header className="mp-home-header">
        <div>
          <h1 className="mp-brand">Movie Picker</h1>
          <p className="mp-tagline">What are you in the mood for?</p>
        </div>
        <button className="mp-logout" onClick={logout} title="Sign out">
          ⎋
        </button>
      </header>

      <div className="mp-choice-grid">
        <button className="mp-choice mp-choice--movie" onClick={() => choose('movie')}>
          <span className="mp-choice-emoji" aria-hidden>
            🎬
          </span>
          <span className="mp-choice-label">Movies</span>
          {stats && (
            <span className="mp-choice-count">
              {stats.movie.remaining} to discover
            </span>
          )}
        </button>
        <button className="mp-choice mp-choice--show" onClick={() => choose('show')}>
          <span className="mp-choice-emoji" aria-hidden>
            📺
          </span>
          <span className="mp-choice-label">TV Shows</span>
          {stats && (
            <span className="mp-choice-count">
              {stats.show.remaining} to discover
            </span>
          )}
        </button>
      </div>

      <p className="mp-hint">
        You'll see genres, scores and bleeped critic reviews — but never the
        title or poster until you swipe to watch.
      </p>

      {user?.is_admin && <AdminSync />}
    </div>
  );
}

function AdminSync() {
  const [status, setStatus] = useState(null);
  const [msg, setMsg] = useState('');

  const refresh = () => {
    api
      .get('/api/sync/status')
      .then((res) => setStatus(res.data))
      .catch(() => {});
  };

  useEffect(refresh, []);

  const trigger = async () => {
    setMsg('Sync started…');
    try {
      await api.post('/api/sync', {});
      setTimeout(refresh, 1500);
    } catch (e) {
      setMsg('Failed to start sync');
    }
  };

  return (
    <div className="mp-admin">
      <div className="mp-admin-row">
        <span>
          Library: {status?.counts?.movie ?? '—'} movies ·{' '}
          {status?.counts?.show ?? '—'} shows
        </span>
        <button className="mp-admin-btn" onClick={trigger}>
          Sync from Plex
        </button>
      </div>
      {status?.last_run && (
        <div className="mp-admin-sub">
          Last run: {status.last_run.status} ({status.last_run.titles_seen} titles,{' '}
          {status.last_run.reviews_fetched} reviews)
        </div>
      )}
      {msg && <div className="mp-admin-sub">{msg}</div>}
    </div>
  );
}
